(ns practitest.frontend.common.bus
  (:require [goog.events :as events]
            [goog.object :as gobj]
            [re-frame.core :as re-frame])
  (:import [goog.events EventTarget Event]))

(defonce ^:private event-target (EventTarget.))

(defn- get-event-name
  [event-type]
  (when event-type
    (str event-type)))

(defn sub
  "Subscribes to events of specific type

  * `event-type` - type of events, can be keyword or string
  * `callback-fn` - callback function (fn [event]) that will be called when
     specific `event-type` is triggered

  Returns id for `unsub` call"
  [event-type callback-fn]
  (.listen event-target
           (get-event-name event-type)
           (fn [event]
             (callback-fn (gobj/get event "__payload")))))

(defn unsub
  "Unsubscribes specific handler (id returned from `sub` call) from bus"
  [id]
  (.unlistenByKey event-target id))

(defn publish
  "Publishes new event with `event-type` and payload on global bus"
  [event-type payload]
  (let [e (Event. (get-event-name event-type))]
    (gobj/set e "__payload" payload)
    (.dispatchEvent event-target e)))
